module.exports = __webpack_public_path__ + "img/Italian-Main-Menu-step-1.391da029.png";